import { connect } from 'react-redux';
import { clearServiceDetails, loadServiceDetails } from '../actions';
import RequireServiceDetails from './RequireServiceDetails';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var serviceDetails = _ref.serviceDetails;
  var displayWithoutServices = _ref2.displayWithoutServices,
    serviceIdentities = _ref2.serviceIdentities;
  return {
    displayWithoutServices: displayWithoutServices,
    serviceIdentities: serviceIdentities,
    status: serviceDetails.status
  };
};
var mapDispatchToProps = {
  clearServiceDetails: clearServiceDetails,
  loadServiceDetails: loadServiceDetails
};
export default connect(mapStateToProps, mapDispatchToProps)(RequireServiceDetails);